/**
 *
 * This is a JavaScript BlackMostros Template.
 *
 * @source: http://www.pronia.es/templates/black-mostros
 *
 * @licstart  The following is the entire license notice for the
 *  JavaScript code in this page.
 *
 * Copyright (C) 2014  David Lemos González
 *
 *
 * The JavaScript code in this page is free software: you can
 * redistribute it and/or modify it under the terms of the GNU
 * General Public License (GNU GPL) as published by the Free Software
 * Foundation, either version 3 of the License, or (at your option)
 * any later version.  The code is distributed WITHOUT ANY WARRANTY;
 * without even the implied warranty of MERCHANTABILITY or FITNESS
 * FOR A PARTICULAR PURPOSE.  See the GNU GPL for more details.
 *
 * As additional permission under GNU GPL version 3 section 7, you
 * may distribute non-source (e.g., minimized or compacted) forms of
 * that code without the copy of the GNU GPL normally required by
 * section 4, provided you include this license notice and a URL
 * through which recipients can access the Corresponding Source.
 *
 * @licend  The above is the entire license notice
 * for the JavaScript code in this page.
 *
 */
import {
  ShowBase,
  } from './blackmostros.showbase.js';


import {
  template,
  when_available,
  check_element,
  fetch_script,
  console_if_debug,
  } from './blackmostros.method.js';

// export default obj => {
//   return new Promise((resolve, reject) => {
//     resolve(Google(obj));
//     reject('bad');
//     });
//   };


let Google = (function($){
  //~ var _doc = document,
  var _sb,
    _first = true,
    _search_load = false,
    // ~ _sb = new ShowBase(),
    _formid,
    _gform,
    _form,
    _form_open_event,
    _form_close_event,
    _start_search_event,
    _end_search_event,
    // _show_class = 'collapse',
    // _google_search_button_selector = "button.gsc-search-button",
    // _google_search_results_selector = "div.custom.google-search-results",
    _show_button,
    _close_button,
    _button,
    _input,
    _results,
    _sel = {
      hide_show_search_button: "div.google-search div.hide-show button.hide-show",
      // ~ hide_show_search_button: "div.google-search div.hide-show button.hide-show-search",
      show_class: 'collapse',
      google_search_button_selector: "button.gsc-search-button",
      google_search_results_selector: "div.custom.google-search-results",
      },
    mpublic = {};

  // function _hide_or_show_google_form(evt, head){
  //   /*
  //    * when shown we need see header height and width
  //    * width minus padding side
  //    *
  //    */
  //   // ~ var width = head.get_width()
  //     // ~ - parseInt(_gform.style.paddingLeft)
  //     // ~ - parseInt(_gform.style.paddingRight);
  //   var  _re;
  //
  //   /* jquery
  //   var width = head.get_width()
  //     - parseInt(_gform.css("padding-left"))
  //     - parseInt(_gform.css("padding-right"));
  //   */
  //   //~ var _call = evt.target || e.srcElement,
  //     //~ _ele = _get_google_search_in_parent(_call);
  //   //~ _re = _hide_show_element(_ele);
  //
  //   //~ _form = $('div.google-search');
  //   _re = _hide_show_element(
  //     _gform
  //     //~ _get_google_search_in_parent(_form)
  //     );
  //   if (_re) {
  //     // dont change css here
  //     // _gform.css({
  //     //   "top": head.get_fixed_height(),
  //     //   "width": width,
  //     //   });
  //     _form.dispatchEvent(_form_open_event);
  //     // ~ _form.trigger(_form_open_event);
  //   } else {
  //     // dont change css here
  //     // _gform.css({
  //     //   "top": head.get_height(),
  //     //   "width": width,
  //     //   });
  //     _form.dispatchEvent(_form_close_event);
  //     // ~ _form.trigger(_form_close_event);
  //   }
  //   return _re;
  // }

  function _load_google_search_js(){
    var url = template.script.url.search;
    return fetch_script(url);
  }

  function _google_search_button_clicked(){
    // allways show google results module
    if (_search_load === false){
      _load_google_search_js();
    };
    _show_google_search_results();
    // _head.fixheader();
  }

  function _google_search_keyup(evt){
    var _k = evt.keyCode;
    // escape and return
    if ([27, 13].indexOf(_k)) {
      if (_k==13) {
        _show_google_search_results();
      } else if (_k==27) {
        _hide_google_search_results();
        // ~ _head.unfixheader();
      }
    }
  }

  function _google_search_close_button_clicked(){
    _hide_google_search_results();
    _hide_google_search_form();
    // ~ _head.unfix();
    // ~ _body.unfix();
    //~ _head.unfixheader();
  }

  function _get_form(){
    return _form;
  }
  mpublic.get_form = _get_form;

  function _init(formid){
  // ~ async function _init(formid){
    _formid = formid;

    // set form when search button clicked
    /*
    _form = $.querySelector(_formid);
    _gform = $.querySelector('div.google-search-form');
    */
    _results = _get_google_search_results();

    /*
    _form = $(_formid);
    _gform = $('div.google-search-form')
    */

    // search show form button dom objects
    _show_button = _get_hide_show_google_search_button();
    mpublic.show_button = _show_button;

    /*
     * set showbase tools
     *
     */
    _sb = ShowBase();
    // ~ _sb = await ShowBase();

    // set events
    _set_events();

    if (_show_button) {
      _show_button.addEventListener(
        "click", _hide_or_show_google_form
      );
      /*
      _show_button.on(
        "click", _hide_or_show_google_form
      );
      */
    }

  }
  mpublic.init = _init;

  function _config_form(){
    // let _bp = new Promise(function(resolve, reject){
    //   // search dom objects when page is ready
    //   _button = _get_google_search_button();
    //
    //
    //   when_available('__gcse', function(){
    //     resolve(true);
    //   });
    // });


    // search dom objects when page is ready
    // _button = _get_google_search_button();

    // set public elements
    mpublic.button = _button;
    if (_button) {
      _input = _get_google_search_input();
      mpublic.input = _input;
      _close_button = _get_google_search_close_button();
      _close_button.on = _close_button.addEventListener;
      mpublic.close_button = _close_button;
      // ~ console.log('Search button configured...', _close_button, _button, _input);
    }
    // ~ else {
      // ~ console.log('Search button not configured...');
    // ~ }
    // ~ else {
      // hide search button
      // ~ _get_selector('div.google-search').classList.add('collapse');
      // ~ _get_selector('div.google-search').style.display = 'collapse';
    // ~ }
  }
  mpublic.config_form = _config_form;

  // set events handlers
  function _on (name, method){
    if (_form) {
      _form.addEventListener(name, method);
      // ~ _form.on(name, method);
    };
  };
  mpublic.on = _on;

  mpublic.hide_or_show_google_form = _hide_or_show_google_form;

  function _show_google_search_results(){
    // allways show google results module when key is return
    /*
     * show results when google response
     *
     */
    if (_search_load === true) {
      return _sb.show_element(_get_google_search_results());
    }
  }
  mpublic.show_google_search_results = _show_google_search_results;

  function _hide_google_search_results(){
    // hide search form and results if esc
    return _sb.hide_element(_get_google_search_results());
  }
  mpublic.hide_google_search_results = _hide_google_search_results;

  function _show_google_search_form(){
    // allways show google form module
    return _sb.show_element(_get_google_search_form());
  }
  mpublic.show_google_search_form = _show_google_search_form;

  function _hide_google_search_form(){
    // hide search form
    return _sb.hide_element(_get_google_search_form());
  }
  mpublic.hide_google_search_form = _hide_google_search_form;


  function _hide_or_show_google_form(evt){
    /*
     * when show search form for first time, see if search js is loaded.
     *
     */
    if (_search_load === false){
      return _load_google_search_js()
      .then(function(e){
        console_if_debug('search loaded', e, evt, $.readyState);
        // init search object
        let _search = search();
        _search.init()

        when_available('__gcse', function(){
          console_if_debug('gcse loaded', $.readyState);

          // set form when search button clicked
          _form = $.querySelector(_formid);
          _gform = $.querySelector('div.google-search-form');

          // ~ _gform.addEventListener('change', function(e){
            // ~ console_if_debug('gform changed', e, document.readyState);
          // ~ });
          // ~ _results = _get_google_search_results();

          console_if_debug(
            'search js loaded', _form, _gform, _gform['children']
            );

          check_element(
            _sel.google_search_button_selector
            // ~ _google_search_button_selector
            )
          .then((element) => {
            _button = element;
            console_if_debug('search button', element, _button);

            // config form must be do when google js is loaded
            _config_form();

            // get selector
            // ~ _re = _get_selector_dom(sel);
            return _hide_or_show_google_form_loaded(evt);

            });
          // ~ _button = _gform.querySelector(_google_search_button_selector);

          // console_if_debug('search button', _button);
          //
          // when_available(_gform['children'], function(){
          //   // ~ _button = _gform.querySelector(_google_search_button_selector);
          //
          //   console_if_debug('search button', _button);
          //
          //   // config form must be do when google js is loaded
          //   _config_form();
          //
          //   // get selector
          //   // ~ _re = _get_selector_dom(sel);
          //   return _hide_or_show_google_form_loaded(evt);
          // });

          _search_load = true;

        });

        // .then(function(e){
        //
        //   // set form when search button clicked
        //   _form = $.querySelector(_formid);
        //   _gform = $.querySelector('div.google-search-form');
        //   // ~ _results = _get_google_search_results();
        //
        //   // config form must be do when google js is loaded
        //   _config_form();
        //
        //   // get selector
        //   // ~ _re = _get_selector_dom(sel);
        //   _search_load = true;
        //   return _hide_or_show_google_form_loaded(evt);
        //
        // })
        // .catch(function(e){
        //     console_if_debug('search not loaded', e);
        //     _search_load = false;
        //   });

      })
      .catch(function(e){
        console_if_debug('search not loaded', e);
        _search_load = false;
      });
    } else {
      return _hide_or_show_google_form_loaded(evt);
    }

  }

  function _hide_or_show_google_form_loaded(evt){
    /*
     * when show search form, hide opened menus and fix header.
     * when fix the header, we need set body margin top size.
     * if run first time, set events
     *
     */
    /*
     * when shown we need see header height and width
     * width minus padding side
     *
     */
    // ~ var width = head.get_width()
      // ~ - parseInt(_gform.style.paddingLeft)
      // ~ - parseInt(_gform.style.paddingRight);
    var  _re;

    /* jquery
    var width = head.get_width()
      - parseInt(_gform.css("padding-left"))
      - parseInt(_gform.css("padding-right"));
    */
    //~ var _call = evt.target || e.srcElement,
      //~ _ele = _get_google_search_in_parent(_call);
    //~ _re = _hide_show_element(_ele);

    //~ _form = $('div.google-search');
    _re = _hide_show_element(
      _gform
      //~ _get_google_search_in_parent(_form)
      );
    if (_re) {
      // dont change css here
      // _gform.css({
      //   "top": head.get_fixed_height(),
      //   "width": width,
      //   });
      _form.dispatchEvent(_form_open_event);
      // ~ _form.trigger(_form_open_event);
    } else {
      // dont change css here
      // _gform.css({
      //   "top": head.get_height(),
      //   "width": width,
      //   });
      _form.dispatchEvent(_form_close_event);
      // ~ _form.trigger(_form_close_event);
    }
    // ~ return _re;


    // ~ var _re = _go.hide_or_show_google_form(evt, _head);

    // fix/unfix header
    // ~ _try_fix_header(_re);

    // if first, add event listeners
    if (_first) {
      _first = false;
      // config form must be do when google js is loaded
      // ~ _config_form();
      _show_google_search_form();

      if (_button) {
        _button.addEventListener(
          "click", _google_search_button_clicked
          );
        _input.addEventListener(
          "keyup", _google_search_keyup
          );

        // some times not found, google change selectors.
        //~ _go.close_button.addEventListener(
        _close_button.on(
          "click", _google_search_close_button_clicked
          );

        // ~ console.log('Search actions configured...');
      }
      // ~ else {
        // ~ console.log('Search actions not configured...');
      // ~ }
    }

    return _re;

  }

  function _set_events(){
    // set google events
    _form_open_event = new Event("form-opened");
    _form_close_event = new Event("form-closed");
    _start_search_event = new Event("start-search");
    _end_search_event = new Event("end-search");

    /*
    _form_open_event = $.Event("form-opened");
    _form_close_event = $.Event("form-closed");
    _start_search_event = $.Event("start-search");
    _end_search_event = $.Event("end-search");
    */
  }

  /**
   * get selector if google js is loaded
   *
   */
  function _get_selector(sel){
    return _get_selector_dom(sel);
    // let _re;
    // if (_search_load === false){
    //   _load_google_search_js()
    //   .then(function(e){
    //     console_if_debug('search loaded', e, sel);
    //     // init search object
    //     let _search = search();
    //     _search.init();
    //
    //     // set form when search button clicked
    //     _form = $.querySelector(_formid);
    //     _gform = $.querySelector('div.google-search-form');
    //     _results = _get_google_search_results();
    //
    //     // get selector
    //     _re = _get_selector_dom(sel);
    //     _search_load = true;
    //   })
    //   .catch(function(e){
    //     console_if_debug('search not loaded', e);
    //     _search_load = false;
    //   });
    // } else {
    //   _re = _get_selector_dom(sel);
    // };
    // return _re;
  }

  function _get_selector_dom(sel){
    let _re = $.querySelector(sel);
    if (_re == undefined) {
      console_if_debug('selector:', sel, 'not found.');
      // wait one second and repeat.
      // while(_re == undefined){
      //   _re = _get_selector_dom(sel);
      //   requestAnimationFrame(function(){});
      // };
      // ~ console.log('selector:', sel, 'not found.');
      }
    return _re;
    // ~ return $(sel);
    //~ return _doc.querySelector(sel);
  };

  function _get_google_search_button(){
    return _get_selector(
      _sel.google_search_button_selector
      // ~ _google_search_button_selector
      );
  }

  function _get_google_search_close_button(){
    // can be different selector
    let _re = _get_selector("a.gsst_a");
    if (_re === null) {
      // or
      _re = _get_selector("div.gsc-clear-button");
      }
    return _re
  }

  function _get_google_search_input(){
    let _re = _get_selector("input.gsc-input");
    return _re;
  }

  // this function dont require search js to work
  function _get_hide_show_google_search_button(){
    return _get_selector_dom(
      _sel.hide_show_search_button
      // ~ "div.google-search div.hide-show button.hide-show-search"
      );
  }

  function _get_google_search_results(){
    return _get_selector(
      _sel.google_search_results_selector
      // ~ _google_search_results_selector
      );
    //~ return _doc.getElementsByClassName("google-search-results");
  }

  function _get_google_search_form(){
    return _get_selector("div.google-search-form");
  }

  function _get_google_search_in_parent(ele) {
    return _get_selector("div.google-search-form");
    //~ return ele.parentNode.parentNode.getElementsByClassName("google-search-form")[0];
  }

  function _hide_show_element(ele){
    var _re = true;
    // hide or show element
    function _hide_show_one(ele){
      _re = ele.classList.contains(
        _sel.show_class
        // ~ _show_class
        );
      ele.classList.toggle(
        _sel.show_class
        // ~ _show_class
        );
      // ~ console.log('_hide_show_one', ele, _re);
      /*
      // get display style
      var _vis = ele.style.display;
      // ~ var _vis = ele.css("display");
      //~ var _vis = ele.style.display;
      if (_vis=='none') {
        _vis = 'inherit';
        _re = true;
      } else {
        _vis = 'none';
        _re = false;
        _sb.hide_element(_get_google_search_results());
      }
      ele.style.display = _vis;
      // ~ ele.css("display", _vis);
      //~ ele.style.display = _vis;
      */
    }

    if (ele instanceof HTMLCollection) {
      [].forEach.call(ele, function(_ele, i) {
        _hide_show_one(_ele);
      });
    } else {
      _hide_show_one(ele);
    }
    return _re
  }

  return mpublic;

});

export {
  Google,
  };
